import React from 'react'
import {useIntl} from 'react-intl'

type Props = {
    showbutton: boolean
}

const SurveyInfo: React.FC<Props> = ({ showbutton }) => {
    const intl = useIntl()
    const portalLink = process.env.REACT_APP_PORTAL_LINK ?? ''
    const apiUrl = process.env.REACT_APP_API_URL ?? ''
    const isEgeCustomer = portalLink.includes('kimlik.ege.edu.tr') || apiUrl.includes('ege.edu.tr')
    const kimlikHomeUrl = portalLink
    const kimlikLogoutUrl = 'https://kimlik.ege.edu.tr/Identity/Account/Login?returnUrl=%2F%3Fpage%3D%252F'

    return (
        <>
            <div className='alert alert-danger d-flex align-items-center p-5 mb-10 mt-10 d-flex flex-column flex-md-row'>
                <div className='col-12 col-md-12'>
                    {intl.formatMessage({ id: 'SurveyInfoText' })}
                    {showbutton &&
                        <>
                            <br />
                            {isEgeCustomer ? (
                                <a className='btn btn-success mt-5' href={kimlikHomeUrl}>
                                    Tek Şifre İle Giriş Ekranına Dön
                                </a>
                            ) : (
                                <a className='btn btn-success mt-5' href={kimlikHomeUrl}>
                                    Tek Şifre İle Giriş Ekranına Dön
                                </a>
                            )}
                        </>
                    }
                </div>
            </div>
        </>
    )
}

export { SurveyInfo }
